import { useEffect } from "react"
import SuccessIcon from "../../Assets/images/success-Featured icon.png"

const SuccessScreen = () => {

    return (
        <div className='mainScreen'>
            <div className="innerScreen">
                <img className='imgStyle' src={SuccessIcon} alt="Payment Success" />
                <p className="headingStyle"> Payment Successful</p>
                <p className="textStyle">  Your payment has been processed successfully. Thank you for subscribing to our service. Enjoy exploring all the features included in your plan. Our team is here to support you whenever you need assistance.</p>
            </div>
        </div>

    )
}
export default SuccessScreen